<template>
  <DxFileUploader
    accept="image/*"
    :upload-url=url
    :uploadHeaders="uploaderCustomData"
    @value-changed="e => files = e.value"
    @onUploadStarted="uploadStarted"
    :active-state-enabled="true"
    :allow-canceling="true"
    :abort-upload="true"
    upload-mode="useButtons"
    upload-button-text="Загрузить"
    select-button-text="выбрать файлы"
    :multiple="true"
  />
  <div
    :style="{display: files.length > 0 ? 'block' : 'none'}"
    class="content"
  >
    <div>
      <h4>Selected Files</h4>
      <div
        v-for="(file, index) in files"
        :key="index"
        class="selected-item"
      >
        <span>Name: {{ file.name }}<br></span>
        <span>Size {{ file.size }}<br></span>
        <span>Type {{ file.type }}<br></span>
        <span>Last Modified Date: {{ file.lastModifiedDate }}</span>
      </div>
    </div>
  </div>
</template>
<script setup>

import {
  DxFileUploader
} from 'devextreme-vue/file-uploader'
import {computed, ref} from 'vue'
import { getUploadURL } from '@/service/http';

defineProps({
  msg: {
    type: String,
    required: true
  }
})
const files = ref([])
const url = computed(() => {
  console.log(window.location)
  return getUploadURL()
})
const uploaderCustomData = ref({login: 't'})
const uploadStarted = (e) => {
  console.log(e)
}
</script>


<style scoped>
h1 {
  font-weight: 500;
  font-size: 2.6rem;
  position: relative;
  top: -10px;
}

h3 {
  font-size: 1.2rem;
}

.greetings h1,
.greetings h3 {
  text-align: center;
}

@media (min-width: 1024px) {
  .greetings h1,
  .greetings h3 {
    text-align: left;
  }
}
.content {
  margin-top: 50px;
  margin-left: 10px;
  display: none;
}
.selected-item {
  margin-bottom: 20px;
}
</style>
